import client from './client';

/**
 * Get Stock On Hand information for an item
 * @param {string} itemCode - The item code
 * @returns {Promise<Object>} SOH data with summary and details
 */
export async function getStockOnHand(itemCode) {
  try {
    const response = await client.get(`/api/soh/${itemCode}`);
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Error fetching SOH:', error);
    return {
      success: false,
      error: error.message || 'Failed to fetch stock on hand data'
    };
  }
}

/**
 * Get Stock On Hand summary for an item (lightweight)
 * @param {string} itemCode - The item code
 * @returns {Promise<Object>} SOH summary
 */
export async function getStockSummary(itemCode) {
  try {
    const response = await client.get(`/api/soh/${itemCode}/summary`);
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Error fetching SOH summary:', error);
    return {
      success: false,
      error: error.message || 'Failed to fetch stock summary'
    };
  }
}
